/* DI MARTINO MAISON · v2 */
/* ---- Carrusel + agregar al carrito ---- */
(function () {
  function carousel(track) {
    if (track.__mc) return; track.__mc = true;
    var sec = track.closest('section');
    var prev = sec.querySelector('[data-prev]'), next = sec.querySelector('[data-next]');
    function step() { var c = track.querySelector('.m-card'); return c ? c.getBoundingClientRect().width + 6 : 300; }
    function update() {
      if (!prev || !next) return;
      prev.disabled = track.scrollLeft < 4;
      next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
    }
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  function flash(btn, ok) {
    if (!btn) return;
    btn.textContent = ok ? '✓' : '×'; btn.classList.add(ok ? 'is-ok' : 'is-err');
    setTimeout(function () { btn.textContent = '+'; btn.classList.remove('is-ok', 'is-err'); }, 1600);
  }
  function closeAll(except) {
    document.querySelectorAll('[data-m-pick-panel]:not([hidden])').forEach(function (p) {
      if (p === except) return;
      p.hidden = true;
      var t = p.parentNode.querySelector('[data-m-pick-toggle]'); if (t) t.setAttribute('aria-expanded', 'false');
      var c = p.closest('.m-card'); if (c) c.classList.remove('is-picking');
    });
  }
  function quickAdd(form) {
    if (form.__ma) return; form.__ma = true;
    var toggle = form.querySelector('[data-m-pick-toggle]');
    var panel = form.querySelector('[data-m-pick-panel]');
    if (toggle && panel) {
      toggle.addEventListener('click', function (e) {
        e.stopPropagation();
        var open = panel.hidden;
        closeAll(panel);
        panel.hidden = !open;
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        var card = form.closest('.m-card'), img = card && card.querySelector('.m-card__img');
        if (card) card.classList.toggle('is-picking', open);
        if (open && card && img) panel.style.bottom = (card.offsetHeight - img.offsetHeight + 8) + 'px';
        if (open) { var f = panel.querySelector('.m-pick__opt:not([disabled])'); if (f) f.focus({ preventScroll: true }); }
      });
      panel.addEventListener('click', function (e) { e.stopPropagation(); });
    }
    form.addEventListener('submit', function (e) {
      if (!window.fetch) return;
      e.preventDefault();
      var id = (e.submitter && e.submitter.name === 'id') ? e.submitter.value : (form.querySelector('[name="id"]') || {}).value;
      if (!id) return;
      var btn = toggle || form.querySelector('button');
      fetch('/cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: id, quantity: 1 })
      }).then(function (r) {
        if (!r.ok) throw new Error('add');
        closeAll(); flash(btn, true);
        return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) {
          document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = c.item_count; });
        });
      }).catch(function () { closeAll(); flash(btn, false); });
    });
  }
  document.addEventListener('click', function () { closeAll(); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(); });

  function boot2(root) {
    root = root || document;
    root.querySelectorAll('[data-m-track]').forEach(carousel);
    root.querySelectorAll('[data-m-add]').forEach(quickAdd);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot2(); }); else boot2();
  document.addEventListener('shopify:section:load', function (e) { boot2(e.target); });
})();
